export default { honors: false, scholarships: false, page: 1, sort: 'name', sortBy: 'asc' };
